"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_core_1 = require("@patternfly/react-core");
require("./ClusterToolbar.css");
const ClusterToolbar = ({ children, validationSection }) => (react_1.default.createElement(react_1.default.Fragment, null,
    validationSection,
    react_1.default.createElement(react_core_1.ActionGroup, null,
        react_1.default.createElement(react_core_1.Toolbar, { id: "cluster-toolbar", className: "cluster-toolbar" },
            react_1.default.createElement(react_core_1.ToolbarContent, { className: "cluster-toolbar__content" }, children)))));
exports.default = ClusterToolbar;
//# sourceMappingURL=ClusterToolbar.js.map